import { useEffect } from "react";
import { getLoggedinUser } from "../../../../../lib/util";
import { getActiveUser } from "../../../../slice/auth-slice";
import { useAppSelector } from "../../../../slice/hooks";
import StorePublicForm from "./store-public-form";

const UserInfo = ({
  onBack,
  onSuccess,
  publicUser,
  activateBackButton,
  setCheckoutState,
  handleLogout,
  cart,
  setShowOrderDetails,
}) => {
  const { loggedInUser } = useAppSelector((state) =>
    getActiveUser(state, getLoggedinUser()),
  );

  useEffect(() => {
    setShowOrderDetails?.(true);

    return () => {
      setShowOrderDetails?.(false);
    };
  }, [setShowOrderDetails]);

  const isLoggedIn = loggedInUser && loggedInUser.user;

  return (
    <>
      {isLoggedIn ? (
        <div className="userinfo-container">
          <div className="userinfo-text">
            <h1>You are logged in as {loggedInUser.user.firstName}</h1>
            <p>
              Click Continue below to proceed with the checkout process, or
              close the cart to continue shopping.
            </p>
            <div style={{ display: "flex", gap: "1rem", marginTop: "10px" }}>
              <button
                onClick={() => setCheckoutState("delivery")}
                className="auth-submit-button"
              >
                Continue
              </button>
              <button onClick={handleLogout} className="auth-secondary-button">
                Logout
              </button>
            </div>
          </div>
        </div>
      ) : (
        <StorePublicForm
          onBack={onBack}
          onSuccess={onSuccess}
          publicUser={publicUser}
          activateBackButton={activateBackButton}
          cart={cart}
        />
      )}
    </>
  );
};

export default UserInfo;
